import { storage } from "./firebaseConfig";

export default storage;